<template>
  <exception-page type="404" />
</template>

<script>
import ExceptionPage from "./ExceptionPage.vue";

export default {
  components: {
    ExceptionPage,
  },
};
</script>

<style scoped></style>
